import TyreSizeCalculatorAnalytics from '../_modules/google_analytics/tyre_size_calculator';
import { Scroll } from './scroll/index';

class TyreSizeCalculator {
    constructor(baseUrl, filterOptions) {
        this.baseUrl = baseUrl;
        this.filterOptions = filterOptions;
        this.allInputs = [
            'originalWidth', 'newWidth',
            'originalHeight', 'newHeight',
            'originalDiameter', 'newDiameter',
        ];
    }

    init () {
        const container = document.querySelector('#tyre-size-calculator-container');
        if (container !== null) {
            const {width, height, diameter} = this.filterOptions;
            this.fillInput('width', 'Width', width);
            this.fillInput('height', 'Profile', height);
            this.fillInput('diameter', 'Diameter', diameter);
        }

        const btnCalculate = document.getElementById("tyreSizeCalculatorCalculate");
        if (btnCalculate) {
            btnCalculate.addEventListener("click", () => {
                for (let i = 0; i < this.allInputs.length; i++) {
                    const input = document.getElementById(this.allInputs[i]);
                    const selectedOption = input.options[input.selectedIndex].value;
                    if (selectedOption === '') {
                        document.getElementById('tyre-size-calculator-error').innerText = 'Please select values from all fields to be be able to calculate the new tyre size.';
                        return false;
                    }
                }

                document.getElementById('tyre-size-calculator-error').innerText = '';
                TyreSizeCalculatorAnalytics.calculate();
                this.doCalculate();
                this.toggleClaculatorResult();
            });
        }

        return this;
    };

    toggleClaculatorResult() {
        const resultContainer = document.getElementById('tyre-size-calculator-container-results');
        if (!resultContainer.classList.contains('tyre-size-calculator-toggle--opened')) {
            resultContainer.classList.add('tyre-size-calculator-toggle--opened');
            resultContainer.style.display = 'block';
            setTimeout(() => {
                Scroll(document.querySelector('.tyre-size-calculator-toggle--opened'));
            }, 500);
        } else {
            Scroll(document.querySelector('.tyre-size-calculator-toggle--opened'));
        }
    }

    doCalculate() {
        const originalWidth = document.getElementById("originalWidth");
        const originalWidthVal = originalWidth.options[originalWidth.selectedIndex].value;

        const newWidth = document.getElementById("newWidth");
        const newWidthVal = newWidth.options[newWidth.selectedIndex].value;

        const originalHeight = document.getElementById("originalHeight");
        const originalHeightVal = originalHeight.options[originalHeight.selectedIndex].value;

        const newHeight = document.getElementById("newHeight");
        const newHeightVal = newHeight.options[newHeight.selectedIndex].value;

        const originalDiameter = document.getElementById("originalDiameter");
        const originalDiameterVal = originalDiameter.options[originalDiameter.selectedIndex].value;

        const newDiameter = document.getElementById("newDiameter");
        const newDiameterVal = newDiameter.options[newDiameter.selectedIndex].value;

        // Overall diameter (mm): 2*(Width * profile/100) + (Diameter * 25.4)
        // Ex for 205/55R16: 2*(205*55%) + (16*25.4)= 225.5+ 406.4 = 631.9
        const originalOverallDiameterMm = 2 * (originalWidthVal * (originalHeightVal / 100)) + (originalDiameterVal * 25.4);
        const newOverallDiameterMm = 2 * (newWidthVal * (newHeightVal / 100)) + (newDiameterVal * 25.4);
        document.getElementById('result-original-overall-diameter-mm').innerText = Math.round(originalOverallDiameterMm);
        document.getElementById('result-new-overall-diameter-mm').innerText = Math.round(newOverallDiameterMm);


        // Overall diameter (in): Overall diameter (mm) [from above] /25.4
        // Ex.631.9/25.4 = 24.88
        const originalOverallDiameterIn = originalOverallDiameterMm / 25.4;
        const newOverallDiameterIn = newOverallDiameterMm / 25.4;
        document.getElementById('result-original-overall-diameter-in').innerText = this.formatFloat(originalOverallDiameterIn);
        document.getElementById('result-new-overall-diameter-in').innerText = this.formatFloat(newOverallDiameterIn);

        // Sidewall Height (mm): (Width * profile/100)
        // Ex. 205*55%= 113
        const originalSidewallHeightMm = originalWidthVal * (originalHeightVal / 100);
        const newSidewallHeightMm = newWidthVal * (newHeightVal / 100);
        document.getElementById('result-original-sidewall-height-mm').innerText = Math.round(originalSidewallHeightMm);
        document.getElementById('result-new-sidewall-height-mm').innerText = Math.round(newSidewallHeightMm);

        // Sidewall Height (in): Sidewall Height (mm) [from above] /25.4
        // Ex. 113/25.4= 4.44
        const originalSidewallHeightIn = originalSidewallHeightMm / 25.4;
        const newSidewallHeightIn = newSidewallHeightMm / 25.4;
        document.getElementById('result-original-sidewall-height-in').innerText = this.formatFloat(originalSidewallHeightIn);
        document.getElementById('result-new-sidewall-height-in').innerText = this.formatFloat(newSidewallHeightIn);

        // Tread width (in) = Width /25.4
        // Ex. 205/25.4= 8.07
        const originalTreadWidthIn = originalWidthVal / 25.4;
        const newTreadWidthIn = newWidthVal / 25.4;
        document.getElementById('result-original-tread-width-in').innerText = this.formatFloat(originalTreadWidthIn);
        document.getElementById('result-new-tread-width-in').innerText = this.formatFloat(newTreadWidthIn);

        // Difference (mm) = Overall diameter (mm) [old size] - Overall diameter (mm) [new size]
        const differenceMm = newOverallDiameterMm - originalOverallDiameterMm;
        const precentageDifference = (100 * Math.round(differenceMm) / Math.round(originalOverallDiameterMm));
        document.getElementById('result-original-difference-mm').innerText = '0 (0%)';
        document.getElementById('result-new-difference-mm').innerText = Math.round(differenceMm) + ' (' + this.formatFloat(precentageDifference) + '%)';

        document.getElementById('result-original-cta-shop').href = this.catalogUrl(originalWidthVal, originalHeightVal, originalDiameterVal);
        document.getElementById('result-new-cta-shop').href = this.catalogUrl(newWidthVal, newHeightVal, newDiameterVal);

        const originalSize = this.formattedSize(originalWidthVal, originalHeightVal, originalDiameterVal);
        document.getElementById('result-original-size').innerText = originalSize;
        TyreSizeCalculatorAnalytics.originalSize(originalSize);

        const newSize = this.formattedSize(newWidthVal, newHeightVal, newDiameterVal);
        document.getElementById('result-new-size').innerText = newSize;
        TyreSizeCalculatorAnalytics.newSize(newSize);
    }

    formatFloat(x) {
        return Number.parseFloat(x).toFixed(2);
    }

    catalogUrl(width, height, diameter) {
        return `${this.baseUrl}/tyre/${width}-${height}-r${diameter}/?s=relevance&d=desc`;
    }

    createOption(value, label) {
        const opt = document.createElement('option');
        opt.value = value;
        opt.innerHTML = label;
        return opt;
    }

    fillInput(type, label, options) {
        let oriInput;
        let newInput;
        switch (type) {
            case 'width':
                oriInput = 'originalWidth';
                newInput = 'newWidth';
                break;
            case 'height':
                oriInput = 'originalHeight';
                newInput = 'newHeight';
                break;
            default:
                oriInput = 'originalDiameter';
                newInput = 'newDiameter';
                break;
        }

        const originalElement = document.getElementById(oriInput);
        const newElement = document.getElementById(newInput);

        for (let idx = 0; idx < options.length; idx++) {
            const val = options[idx][0];
            originalElement.appendChild(this.createOption(val, val));
            newElement.appendChild(this.createOption(val, val));
        }
    }

    formattedSize(width, height, diameter) {
        let formattedSize = `${width}/${height}R${diameter}`;
        if (height === '0' || height < 1) {
            formattedSize = `${width}R${diameter}`;
        }

        return formattedSize;
    }
}

export default TyreSizeCalculator;